import axios from 'axios'
import { INCLUIR_FORMA_PAGAMENTO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function informarComprovantePagamento (formaPagamento, idEmpresa) {
  const url = `${URL}/formapagamento/empresa/${idEmpresa}/incluir-comprovante-venda`;
  return dispatch => axios.post(url,formaPagamento , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: INCLUIR_FORMA_PAGAMENTO,
        payload: response
      })
  );
}
